var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"container-fluid"},[_c('h1',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.deviceName))]),(_vm.deviceId)?_c('device-status',{attrs:{"device-id":_vm.deviceId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }